<template>
  <div id="app">
    <common-head v-show="!$route.meta.header"></common-head>
    <router-view class="routerView"/>
    <common-foot v-show="!(path ==='/partyBuilding')"></common-foot>
  </div>
</template>

<script>
import CommonHead from "./components/views/Index/header.vue";
import CommonFoot from "./components/views/Index/footer.vue";
import { userApi } from "./api/user.js";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "App",
  data() {
    return {
      path:''
    };
  },
  computed: {
    // ...mapGetters(["requesting", "result", "loginIn", "signFlg"])
  },
  mounted() {
    // userApi.getMenu({ id: 1 }).then(() => {
    //   console.log(1);
    // });
    //  userApi.postMenu({ id: 1 }).then(() => {
    // });
    this.path = this.$route.path;
  },
  methods: {
    //  ...mapActions(["openSign"])
  },
  components: {
    CommonHead,
    CommonFoot
  },
  watch:{
      $route(to,from){
          this.path = to.path
      }
  }

};
</script>

<style>
#app {
}
.routerView{
  min-height: 600px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue